import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { CREATE_PARTICIPANT, GET_PARTICIPANT_COLLECTION } from '../actions';

import {
  createParticipantSuccess,
  createParticipantError,
  getParticipantCollectionSuccess,
  getParticipantCollectionError
} from './actions';

const CREATE_PARTICIPANT_ERROR = "Participant create fails.";
const GET_PARTICIPANT_COLLECTION_ERROR = "Get participant collection fails.";

const createParticipantAsync = async (payload) => {
  let dataReturned;
  try {
    dataReturned = payload.nodeEdge.node_edge_id > 0 ? await centralApiAxios.put("node_edges?id=" + payload.nodeEdge.node_edge_id, payload.nodeEdge) : await centralApiAxios.post("node_edges", payload.nodeEdge);
    if (dataReturned.data && dataReturned.data.node_edge_id > 0) {
      return {
        participant: dataReturned.data,
        isItemCreate: !(payload.nodeEdge.node_edge_id > 0),
        message: null,
      };
    }
    return { message: CREATE_PARTICIPANT_ERROR };
  } catch (error) {
    return {
      message: CREATE_PARTICIPANT_ERROR,
    };
  }
};

function* createParticipant({ payload }) {
  const { history } = payload;
  try {
    const resultReturned = yield call(createParticipantAsync, payload);
    if (!resultReturned.message) {
      yield put(createParticipantSuccess(resultReturned.participant));
      if (resultReturned.isItemCreate)
        {
          history.push("/app/participant-overview/" + payload.collectionItemId + "/" + payload.nodeEdge.from_node_id + "/" + resultReturned.participant.node_edge_id + "/" +payload.overviewPageId);
        }
        else
        {
          history.push("/app/collectionitempeople/" + + payload.collectionItemId)
        }
      window.location.reload();
    } else {
      yield put(createParticipantError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(createParticipantError(CREATE_PARTICIPANT_ERROR));
  }
}

export function* watchCreateParticipant() {
  yield takeEvery(CREATE_PARTICIPANT, createParticipant);
}

const getParticipantCollectionAsync = async (payload) => {
  try {
    let participantCollection;
    if (payload.participantCollectionId > 0) {
      const recordCollectionReturned = await centralApiAxios.get("collections/" + payload.participantCollectionId);
      if (recordCollectionReturned.data) {
        participantCollection = recordCollectionReturned.data;
      }
    } else {
      const collectionsReturned = await centralApiAxios.get("collections?parent_collection_id=" + payload.parentCollectionIdOfParticipantCollection + "&verbType=2");
      if (collectionsReturned.data) {
        participantCollection = collectionsReturned.data.items.filter(c => c.node_edge_relationship_enabled).find(c => c.relation_of_record_id = payload.parentCollectionIdOfParticipantCollection);
      }
    }
    if (participantCollection) {
      const relationOfCollectionReturned = participantCollection.relation_of_record_id > 0 ? await centralApiAxios.get("collections/" + participantCollection.relation_of_record_id) : null;
      const relationTypeCollectionReturned = participantCollection.relation_type_record_id > 0 ? await centralApiAxios.get("collections/" + participantCollection.relation_type_record_id) : null;
      const relationOfNodeReturned = payload.relationOfNodeId > 0 ? await centralApiAxios.get("nodes/" + payload.relationOfNodeId) : null;
      return {
        participantCollection: {
          collection: participantCollection,
          relationOfCollection: relationOfCollectionReturned ? relationOfCollectionReturned.data : null,
          relationTypeCollection: relationTypeCollectionReturned ? relationTypeCollectionReturned.data : null,
          relationOfNode: relationOfNodeReturned ? relationOfNodeReturned.data : null
        },
        message: null,
      };
    }
    return { message: GET_PARTICIPANT_COLLECTION_ERROR };
  } catch (error) {
    return {
      message: GET_PARTICIPANT_COLLECTION_ERROR,
    };
  }
};

function* getParticipantCollection({ payload }) {
  try {
    const resultReturned = yield call(getParticipantCollectionAsync, payload);
    if (!resultReturned.message) {
      yield put(getParticipantCollectionSuccess(resultReturned.participantCollection));
    } else {
      yield put(getParticipantCollectionError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(getParticipantCollectionError(GET_PARTICIPANT_COLLECTION_ERROR));
  }
}

export function* watchGetParticipantCollection() {
  yield takeEvery(GET_PARTICIPANT_COLLECTION, getParticipantCollection);
}

export default function* rootSaga() {
  yield all([
    fork(watchCreateParticipant),
    fork(watchGetParticipantCollection)
  ]);
}
